import { Tooltip } from "@mui/material";

import styles from "./styles.module.scss";

interface ButtonDeletedProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  handleDeleteItem: () => void;
}

export function ButtonDeleted({
  handleDeleteItem,
  ...rest
}: ButtonDeletedProps) {
  return (
    <Tooltip placement="top" title="Excluir">
      <button
        {...rest}
        type="button"
        className={`${styles.buttonDeleted}`}
        onClick={() => handleDeleteItem()}
      ></button>
    </Tooltip>
  );
}